export type LevelKey = 'beginner' | 'mid' | 'challenge'

export interface Level {
  key: LevelKey
  label: string
  dotClass: string
}

export const levels: Level[] = [
  { key: 'beginner', label: 'Początkujący', dotClass: 'bg-level-beginner' },
  { key: 'mid', label: 'Średni', dotClass: 'bg-level-mid' },
  { key: 'challenge', label: 'Wyzwanie', dotClass: 'bg-level-challenge' },
]

/** The 16-week semester plan. */
export const semesterWeeks: string[] = [
  'Swing feel i comping',
  'Rytm i metrum',
  'Akordy septymowe',
  'Voicingi shell',
  'ii-V-I',
  'ii-V-I w molu',
  'Dźwięki prowadzące',
  'Arpeggia',
  'Drop-2',
  'Skale modalne',
  'Frazowanie',
  'Artykulacja',
  'Słownictwo bebopowe',
  'Analiza standardu',
  'Solówka na standard',
  'Jam session + ocena',
]
